module.exports = __webpack_public_path__ + "static/ws-logo.527d2a59.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/WinterHero/ws-logo.png
// module id = 463
// module chunks = 35783957827783